import React, { Suspense } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { Button } from 'js/components/common/Button';
import { Balance } from 'js/components/main/Balance';
import { ManagedPopup } from 'js/components/common/Popup';
import { useOnClose } from 'js/components/common/PopupManager';

import style from './BalancesPopup.scss';

export const BalancesPopup = () => {
    const closeManagedPopup = useOnClose();
    const translate = useTranslations('playtech.mobile.system.');

    return (
        <ManagedPopup buttons={false} isModal={true} className={style.container} onClose={closeManagedPopup}>
            <div className={style.titleRow}>
                 <div className={style.titleInfo}>
                     <span className={style.balanceLogo}></span>
                     <span>{translate('playtech.mobile.system.header.balance')}</span>
                 </div>
                <Suspense fallback="">
                    <Balance type="sportsbook_gaming_balance" />
                </Suspense>
            </div>
            <div className={style.balanceInfo}>
                <div className={style.balanceRow}>
                      {translate('playtech.mobile.system.header.totalWithdrawableBalance')}
                    <Suspense fallback="">
                        <Balance type="withdrawable_balance" />
                    </Suspense>
                </div>
                <div className={style.controls}>
                    <Button
                        type="button"
                        className={style.linkBalance}
                        size="small"
                        href="/balance"
                        onClick={closeManagedPopup}
                    >
                        {translate('playtech.mobile.system.header.myBalances')}
                    </Button>
                    <Button
                        className={style.linkBonusHistory}
                        type="button"
                        size="small"
                        href="/kambi#bonus-offers"
                        onClick={closeManagedPopup}
                    >
                        {translate('playtech.mobile.system.header.myBonuses')}
                    </Button>
                    <Button
                        className={style.linkDeposit}
                        type="button"
                        size="small"
                        href="/deposit"
                        onClick={closeManagedPopup}
                    >
                        {translate('playtech.mobile.system.header.deposit')}
                    </Button>
                </div>
            </div>
        </ManagedPopup>
    );
};
